import React from 'react';
import { Radio, RadioProps } from "@heroui/react";
import { cn } from "@heroui/react";
// import { Check } from 'lucide-react';

interface StyledRadioProps extends RadioProps {
  children: React.ReactNode;
}

const StyledRadio: React.FC<StyledRadioProps> = ({ children, className, ...props }) => {
  return (
    <Radio
      {...props}
      classNames={{
        base: cn(
          "flex-1 m-0 min-w-24",
          "data-[selected=true]:border-primary",
          className
        ),
        wrapper: "hidden",
        labelWrapper: "w-full m-0 p-0"
      }}
    >
      <div className={cn(
        "w-full py-3 px-2 flex items-center justify-between",
        "bg-default-100 hover:bg-default-200",
        "rounded-lg cursor-pointer transition-colors",
        "border-2 border-transparent",
        "group-data-[selected=true]:border-primary",
        "group-data-[selected=true]:bg-primary-50"
      )}>
        <span className="w-full text-sm text-center">{children}</span>
        {/* <span className="w-4 h-4 rounded-full border-2 border-default-400 group-data-[selected=true]:border-primary relative">
          <Check className="h-3 w-3 text-primary absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-0 group-data-[selected=true]:opacity-100 transition-opacity" />
        </span> */}
      </div>
    </Radio>
  );
};

export default StyledRadio; 